var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"size-full",attrs:{"id":"app"}},[_c('div',{staticClass:"size-full flex flex-col"},[_c('router-view',{staticClass:"flex-1"}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"flex items-center py-2 px-4 justify-center"},[_c('span',{},[_vm._v("备案号：")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("新ICP备2024009053号-1")])])
}]

export { render, staticRenderFns }